import {
  useState, useRef, useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { DataInput, getFont } from '@twnel/web-components';
import getCaretCoordinates from 'textarea-caret';
import SpecDropdown from './SpecDropdown';
import OptionsBar from './OptionsBar';

export const INPUT_TYPES = {
  INPUT: 'input',
  TEXTAREA: 'textarea',
};

export const InteractiveInput = ({
  disabled = false, invalid = false, onChange = () => null,
  placeholder = '', refMenuOnKeydown = true, type,
  value, optionsVisible = false, fontFamily = '',
}) => {
  const childrenRef = useRef(null);
  const wrapperRef = useRef(null);
  const font = useSelector(getFont);
  const customFont = fontFamily ? ({
    ...font,
    family: fontFamily,
    size: 13.5,
  }) : font;
  const [isSpecVisible, setspecVisible] = useState(false);
  const [specPosition, setSpecPosition] = useState({ top: 0, left: 0 });
  const [width, setWidth] = useState(300);

  useEffect(() => {
    setWidth(wrapperRef.current.offsetWidth);
  }, []);

  const onChangedetectFunctionCharacter = (componentRef) => {
    const { top, left } = getCaretCoordinates(componentRef, componentRef.selectionEnd);
    // SpecDropdown se ubica con `{ top, left }` (px), justo debajo del cursor.
    setSpecPosition({ top: top + 20 + 16, left: left + 15 });
    setspecVisible(true);
  };

  const toggleVariablesDisplay = (display) => {
    setspecVisible(display);
  };

  const dropdownOnChange = (variable) => {
    if (childrenRef.current) {
      childrenRef.current.maskInsert(variable);
    }
  };

  return (
    <div style={{ position: 'relative' }} ref={wrapperRef}>
      <OptionsBar childrenRef={childrenRef} disabled={disabled} optionsVisible={optionsVisible}>
        <DataInput
          maxWidth={width}
          font={customFont}
          ref={childrenRef}
          value={value || ''}
          onChange={onChange}
          type={type}
          onVariableType={onChangedetectFunctionCharacter}
          placeholder={placeholder}
          invalid={invalid}
          disabled={disabled}
          refMenuOnKeydown={refMenuOnKeydown}
          onFocus={() => null}
        />
      </OptionsBar>
      {isSpecVisible ? (
        <SpecDropdown
          position={specPosition}
          toggleDisplay={toggleVariablesDisplay}
          onChange={dropdownOnChange}
        />
      ) : null}
    </div>
  );
};

InteractiveInput.propTypes = {
  disabled: PropTypes.bool,
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  refMenuOnKeydown: PropTypes.bool,
  invalid: PropTypes.bool,
  optionsVisible: PropTypes.bool,
  fontFamily: PropTypes.string,
};
